(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* gift cards unwrap when they scroll into view */
  var gifts = Array.prototype.slice.call(document.querySelectorAll('.gift__item[data-wrap]'));
  if (gifts.length) {
    if (reduce || !hasIO) {
      gifts.forEach(function (g) { g.classList.add('no-anim', 'is-open'); });
    } else {
      var go = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var g = e.target, i = gifts.indexOf(g);
          setTimeout(function () { g.classList.add('is-open'); }, 450 + i * 380);
          go.unobserve(g);
        });
      }, { threshold: 0.55 });
      gifts.forEach(function (g) {
        go.observe(g);
        g.addEventListener('mouseenter', function () { g.classList.add('is-open'); });
        g.addEventListener('focus', function () { g.classList.add('is-open'); });
      });
    }
  }

  /* gentle parallax */
  var px = document.querySelectorAll('[data-parallax]');
  if (px.length && !reduce) {
    var ticking = false;
    function para() {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var off = (r.top + r.height / 2 - vh / 2) * -0.06;
        el.style.transform = 'translateY(' + off.toFixed(1) + 'px) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(para); } }, { passive: true });
    para();
  }

  /* real delivery estimate (business days) */
  document.querySelectorAll('[data-deliv]').forEach(function (el) {
    var list = (el.getAttribute('data-countries') || '').toUpperCase().split(',').map(function (s) { return s.trim(); });
    var country = (el.getAttribute('data-country') || '').toUpperCase();
    if (list.indexOf(country) === -1) return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 5, max = parseInt(el.getAttribute('data-max'), 10) || 8;
    function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var f;
    try { f = new Intl.DateTimeFormat(el.getAttribute('data-locale') || undefined, { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { f = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' }); }
    var txt = el.getAttribute('data-text') || '';
    var out = el.querySelector('[data-deliv-text]');
    var parts = txt.split(/\{from\}|\{to\}/);
    out.textContent = '';
    out.appendChild(document.createTextNode(parts[0] || ''));
    var b1 = document.createElement('b'); b1.textContent = f.format(add(min)); out.appendChild(b1);
    out.appendChild(document.createTextNode(parts[1] || ''));
    var b2 = document.createElement('b'); b2.textContent = f.format(add(max)); out.appendChild(b2);
    out.appendChild(document.createTextNode(parts[2] || ''));
    el.hidden = false;
  });

  /* heat slider */
  document.querySelectorAll('[data-heat]').forEach(function (s) {
    var r = s.querySelector('[data-heat-range]'); if (!r) return;
    var labels = [];
    try { labels = JSON.parse(s.querySelector('[data-heat-labels]').textContent) || []; } catch (e) {}
    var num = s.querySelector('[data-heat-num]'), name = s.querySelector('[data-heat-name]');
    function set() {
      var v = parseInt(r.value, 10), max = parseInt(r.max, 10);
      var t = max > 1 ? (v - 1) / (max - 1) : 1;
      s.style.setProperty('--heat', t.toFixed(3));
      r.style.setProperty('--fill', (t * 100).toFixed(1) + '%');
      var l = String(labels[v - 1] || '').trim();
      num.textContent = v; name.textContent = l;
      r.setAttribute('aria-valuetext', v + (l ? ' – ' + l : ''));
    }
    var touched = false;
    r.addEventListener('input', function () { touched = true; set(); });
    set();
    if (!reduce && hasIO) {
      var start = parseInt(r.value, 10), max = parseInt(r.max, 10);
      var ho = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        ho.disconnect();
        var seq = [], v;
        for (v = 1; v <= max; v++) seq.push(v);
        for (v = max - 1; v >= start; v--) seq.push(v);
        seq.forEach(function (val, i) {
          setTimeout(function () { if (!touched) { r.value = val; set(); } }, 300 + i * 260);
        });
      }, { threshold: 0.5 });
      ho.observe(s);
    }
  });

  /* sticky add-to-bag bar: shown once the main button has scrolled above the screen */
  var bar = document.querySelector('[data-sbar]');
  var main = document.querySelector('[data-product] [data-add]');
  if (bar && main) {
    var sbtn = bar.querySelector('[data-sbar-btn]');
    var sprice = bar.querySelector('[data-sbar-price]');
    var mprice = document.querySelector('[data-product] [data-price]');
    function sync() {
      if (mprice && sprice) sprice.textContent = mprice.textContent;
      sbtn.disabled = main.disabled;
      sbtn.textContent = main.textContent.trim();
    }
    sync();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      mo.observe(main, { attributes: true, childList: true, characterData: true, subtree: true });
      if (mprice) mo.observe(mprice, { childList: true, characterData: true, subtree: true });
    }
    var sbTick = false;
    function checkBar() {
      sbTick = false;
      var past = main.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('is-on') !== past) {
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        sbtn.tabIndex = past ? 0 : -1;
      }
    }
    function queueBar() { if (!sbTick) { sbTick = true; requestAnimationFrame(checkBar); } }
    window.addEventListener('scroll', queueBar, { passive: true });
    window.addEventListener('resize', queueBar);
    checkBar();
    sbtn.addEventListener('click', function () {
      if (main.disabled) { main.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      main.click();
    });
  }
})();
